(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });

  function applyJetVaroPolish() {
    if (!document.getElementById('jet-varo-global-polish')) {
      const style = document.createElement('style');
      style.id = 'jet-varo-global-polish';
      style.textContent = `
        details > summary,
        details[open] > summary {
          color: inherit !important;
        }

        .seese-faq summary {
          list-style: none;
          position: relative;
          padding-right: 44px;
        }
        .seese-faq summary::-webkit-details-marker { display: none; }
        .seese-faq summary::after {
          content: '+';
          position: absolute;
          right: 3px;
          top: 50%;
          transform: translateY(-50%);
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30px;
          height: 30px;
          border: 1px solid #4a4a4a;
          border-radius: 50%;
          color: #b8ff2c;
          font-size: 24px;
          font-weight: 400;
          line-height: 1;
        }
        .seese-faq details[open] summary::after { content: '−'; }

        .jet-varo-back-to-shop {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin: 18px 20px 4px;
          padding: 11px 16px;
          border: 1px solid rgba(255,255,255,.22);
          border-radius: 999px;
          color: #f7f7f5;
          background: rgba(18,18,18,.82);
          text-decoration: none;
          font-weight: 750;
          font-size: 14px;
          line-height: 1;
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
        }
        .jet-varo-back-to-shop:hover,
        .jet-varo-back-to-shop:focus-visible {
          border-color: #b8ff2c;
          color: #b8ff2c;
        }
        @media (max-width: 749px) {
          .jet-varo-back-to-shop { margin: 14px 13px 2px; }
        }
      `;
      document.head.appendChild(style);
    }

    const faq = document.querySelector('.seese-faq');
    if (faq) {
      const batteryQuestion = [...faq.querySelectorAll('details')].find(
        (item) => item.querySelector('summary')?.textContent?.trim() === 'How long does the battery last?'
      );
      const batteryAnswer = batteryQuestion?.querySelector('p');
      if (batteryAnswer) {
        batteryAnswer.textContent = 'Battery runtime varies depending on the power level used, operating conditions and how the blower is used.';
      }
    }

    const path = window.location.pathname.toLowerCase();
    if (path.includes('how-it-works') && !document.querySelector('.jet-varo-back-to-shop')) {
      const backLink = document.createElement('a');
      backLink.className = 'jet-varo-back-to-shop';
      backLink.href = '/';
      backLink.setAttribute('aria-label', 'Back to shop');
      backLink.innerHTML = '<span aria-hidden="true">←</span><span>Back to Shop</span>';

      const main = document.querySelector('main') || document.querySelector('#MainContent') || document.body;
      main.insertBefore(backLink, main.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyJetVaroPolish, { once: true });
  } else {
    applyJetVaroPolish();
  }
})();
